export const ChannelConstants = {
    pluginKey: process.env.REACT_APP_CHANNEL_PLUGIN_KEY ?? "",
};
